import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d4cb1e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid font-goldplay" }
const _hoisted_2 = { class: "row align-items-center border-bottom border-dark m-1" }
const _hoisted_3 = { class: "col-11 py-0" }
const _hoisted_4 = { class: "row align-items-center border-bottom" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 py-2 px-0 text-black row-header" }, " Day/Date ", -1))
const _hoisted_6 = { class: "row align-items-center border-bottom" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 py-2 px-0 text-black row-header" }, " Time ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 py-2 px-0 text-black row-header" }, " Title ", -1))
const _hoisted_9 = {
  key: 0,
  class: "row align-items-center"
}
const _hoisted_10 = { class: "col-3 py-2 px-0 text-black row-header" }
const _hoisted_11 = { class: "col d-flex align-items-center font-14px" }
const _hoisted_12 = {
  key: 0,
  class: "mb-0 me-2"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "col-1" }
const _hoisted_15 = { class: "dropstart" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn p-0 rounded-0 border-0 kebab-button",
  "data-bs-toggle": "dropdown",
  "aria-label": "open session menu"
}, null, -1))
const _hoisted_17 = { class: "dropdown-menu p-0 rounded-0 border-0 shadow" }

import { SessionListItemViewModel } from '../SessionListItem/SessionListItem.interfaces'
import CheckCircleBlue from '@/icons/CheckCircleBlue.vue'
import TagInfoModal from '../TagInfoModal/TagInfoModal.vue'
import CoachingSessionInfoModal from '../CoachingSessionInfoModal/CoachingSessionInfoModal.vue'
import DocumentDownloadModal from '../DocumentDownloadModal/DocumentDownloadModal.vue'
import { useClassroomStudentService } from '../ClassroomStudentService'
import { downloadFile } from '@/utils/downloadFile'
import { CourseTag, Event as ClassroomEvent } from '@/types/api'
import VideoCamera from '@/icons/VideoCamera.vue'
import DocumentIcon from '@/icons/DocumentIcon.vue'
import MultiTagIcon from '@/icons/icon_multitag.vue'
import { useEventBus } from '@vueuse/core'
import { registerSessionKey, cancelSessionKey } from '@/config/events'
import { useSessionRegistryStore } from '@/components/SessionRegistryStore'
import { formatTableDateTime } from '@/utils/date'


import { defineComponent, defineProps, ref } from 'vue'
const __default__ = defineComponent({
  name: 'SessionMoblieListItem'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {},
    instructorName: {},
    disabled: { type: Boolean },
    isLastRow: { type: Boolean },
    eventTags: {},
    isLsat: { type: Boolean }
  },
  setup(__props: any) {

const props =
  __props

const registerSessionEventBus = useEventBus(registerSessionKey)
const cancelSessionEventBus = useEventBus(cancelSessionKey)
const { sessionActions } = useSessionRegistryStore()
const classroomStudentService = useClassroomStudentService()
const dateString = formatTableDateTime(props.modelValue)
const hasDocuments = props.modelValue.event.documentFileNames?.length > 0
const eventStartingSoon = props.modelValue.showRegistered && startsWithin24Hours(props.modelValue.event)
const showInstructorRow = props.isLsat || hasDocuments || eventStartingSoon
const showSessionInfo = ref(false)
const showTagInfo = ref(false)
const showDocumentDownloadModal = ref(false)
const documentsDownloading = ref([''])

function startsWithin24Hours(event: ClassroomEvent) {
  if (!event.startDate || !event.startTime) {
    return false
  }
  const start = Date.parse(`${event.startDate}T${event.startTime}Z`)
  return start - Date.now() < 1000 * 60 * 60 * 24
}

function handleRegisterClick() {
  sessionActions.selectSession(props.modelValue)
  registerSessionEventBus.emit(props.modelValue.sessionId)
}

function handleCancelClick() {
  cancelSessionEventBus.emit({ ...props.modelValue.event, id: props.modelValue.sessionId })
}

function handleAddToCalendarClick() {
  classroomStudentService.downloadCalendarInvite(props.modelValue.event, props.modelValue.isLSAT)
}

function handleSessionInfoClick() {
  showSessionInfo.value = true
}

function handleDownloadDocuments() {
  if (props.modelValue.event.documentFileNames.length === 1) {
    downloadFiles([props.modelValue.event.documentFileNames[0]])
  } else {
    openDocumentDownloadModal()
  }
}
async function downloadFiles(fileNameList: string[]) {
  documentsDownloading.value = [ ...fileNameList ]
  try{
      await fileNameList.forEach(async (fileName) => {
        const file = await classroomStudentService.fetchEventDocument(props.modelValue.sessionId, fileName)
        if (file) {
          downloadFile(file, fileName)
          documentsDownloading.value = documentsDownloading.value.filter(f => f !== fileName)
        }
    })
  } catch (e) {
    documentsDownloading.value = []
    throw e
  }
}

function openDocumentDownloadModal() {
  showDocumentDownloadModal.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", {
              class: _normalizeClass(['col d-flex align-items-center font-14px', {'fw-bolder': _ctx.modelValue.showRegistered}])
            }, [
              (_ctx.modelValue.showRegistered)
                ? (_openBlock(), _createBlock(CheckCircleBlue, {
                    key: 0,
                    class: "checkmark-svg me-2 size-24px",
                    role: "img",
                    "aria-label": "currently enrolled session"
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_unref(dateString)), 1)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", {
              class: _normalizeClass(['col font-14px', {'fw-bolder': _ctx.modelValue.showRegistered}])
            }, _toDisplayString(_ctx.modelValue.localStartEndTime), 3)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(['row align-items-center', { 'border-bottom': _unref(showInstructorRow) }])
          }, [
            _hoisted_8,
            _createElementVNode("div", {
              class: _normalizeClass(['col d-flex align-items-center font-14px', {'fw-bolder': _ctx.modelValue.showRegistered}])
            }, [
              _createTextVNode(_toDisplayString(_ctx.modelValue.event.title) + " ", 1),
              _createElementVNode("button", {
                class: "btn ms-2 p-0 lh-1",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showTagInfo.value = true))
              }, [
                (_ctx.eventTags.length == 1)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "session-list-item__info-badge fw-bold font-14px",
                      style: _normalizeStyle({ color: _ctx.eventTags[0].color })
                    }, " (" + _toDisplayString(_ctx.eventTags[0].abbreviation) + ") ", 5))
                  : (_ctx.eventTags.length > 1)
                    ? (_openBlock(), _createBlock(MultiTagIcon, {
                        key: 1,
                        class: "size-20px"
                      }))
                    : _createCommentVNode("", true)
              ])
            ], 2)
          ], 2),
          (_unref(showInstructorRow))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.isLsat ? "Instructor" : ""), 1),
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.isLsat)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                        _createElementVNode("button", {
                          class: _normalizeClass(['session-list-item__cell btn btn-link p-0 link-blue text-start font-14px pe-4', {'fw-bolder': _ctx.modelValue.showRegistered}]),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSessionInfoClick()))
                        }, _toDisplayString(_ctx.instructorName), 3)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(eventStartingSoon))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "link-btn me-4",
                        href: _ctx.modelValue.event.meetingLink,
                        target: "_blank"
                      }, [
                        _createVNode(VideoCamera)
                      ], 8, _hoisted_13))
                    : _createCommentVNode("", true),
                  hasDocuments
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "btn p-0 lh-1 rounded-0",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (handleDownloadDocuments()))
                      }, [
                        _createVNode(DocumentIcon, { class: "size-20px" })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              (_ctx.modelValue.showRegistered)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "dropdown-item p-3 px-4 lh-base border-bottom",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (handleCancelClick()))
                  }, " Cancel/Reschedule Session "))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "dropdown-item p-3 px-4 lh-base border-bottom",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (handleRegisterClick()))
                  }, " Register for Session ")),
              (_ctx.modelValue.showRegistered)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "dropdown-item p-3 px-4 lh-base border-bottom",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (handleAddToCalendarClick()))
                  }, " Add to Calendar "))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "dropdown-item p-3 px-4 lh-base",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (handleSessionInfoClick()))
              }, " Session" + _toDisplayString(_ctx.isLsat ? "/Instructor" : "") + " Info ", 1),
              hasDocuments
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    class: "dropdown-item p-3 px-4 lh-base border-top",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (handleDownloadDocuments()))
                  }, " Download Documents "))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(TagInfoModal, {
      visible: showTagInfo.value,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((showTagInfo).value = $event)),
      "coaching-session": _ctx.modelValue,
      "event-tags": _ctx.eventTags
    }, null, 8, ["visible", "coaching-session", "event-tags"]),
    _createVNode(CoachingSessionInfoModal, {
      visible: showSessionInfo.value,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((showSessionInfo).value = $event)),
      "coaching-session": _ctx.modelValue
    }, null, 8, ["visible", "coaching-session"]),
    _createVNode(DocumentDownloadModal, {
      visible: showDocumentDownloadModal.value,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((showDocumentDownloadModal).value = $event)),
      "file-names": _ctx.modelValue.event.documentFileNames ?? [],
      "documents-downloading": documentsDownloading.value,
      onDownloadFiles: downloadFiles
    }, null, 8, ["visible", "file-names", "documents-downloading"])
  ], 64))
}
}

})